'use client'

import { CheckCircleIcon } from '@heroicons/react/24/solid'
import { Button } from '@/General/Button'
import { Modal } from '@/Modal'

export const AlreadyPurchasedModal = ({
  isOpen,
  productName,
  onClose,
}: AlreadyPurchasedModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="relative">
        <div className="relative bg-gradient-to-br from-amber-50 to-orange-50 px-6 pt-8 pb-6 overflow-hidden">
          <div className="flex flex-col items-center">
            <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center shadow-lg transition-all duration-200 transform scale-100 opacity-100">
              <CheckCircleIcon className="w-8 h-8 text-white" />
            </div>
            <div className="mt-4 text-center transition-all duration-200 opacity-100">
              <h3 className="text-xl font-bold text-gray-900 mb-1">
                Already Purchased
              </h3>
              <p className="text-amber-700 font-medium">{productName}</p>
            </div>
          </div>
        </div>
      </div>
      
      <div className="px-6 py-6">
        <div className="flex items-center space-x-3 mb-6">
          <div>
            <p className="text-lg text-gray-900">
              You have already purchased this download. There is no need to purchase it again.
            </p>
          </div>
        </div>
        
        <div className="space-y-3">
          <Button 
            color="green" 
            onClick={onClose}
            className="w-full"
          >
            Close
          </Button>
          <Button 
            color="gray" 
            href="/account/downloads"
            className="w-full"
          >
            View my downloads
          </Button>
        </div>
      </div>
    </Modal>
  )
}

interface AlreadyPurchasedModalProps {
  isOpen: boolean
  productName: string
  onClose: () => void
}
